export default __webpack_public_path__ + "static/media/geometry-artwork-4.dc17a701.webp";